module.exports = __webpack_public_path__ + "static/search-6d5cdc75893da9959407b2d823dbfb3b.jpg";